import { createStore } from '@/utils/createStore'

export interface PayoutRow {
  id: string
  payoutNumber: string
  generatorId: string
  generatorName: string
  // Which real generator invoice (auto-created when its allocation was
  // approved) this payout settles. Optional so payout records saved before
  // this link existed still load — but a new payout should always carry one.
  invoiceId?: string
  invoiceNumber?: string
  period: string
  totalUnits: number
  tariff: number
  grossAmount: number      // units × tariff — the invoice's base (pre-GST) amount
  gstAmount?: number       // the invoice's own GST amount, carried through so it's paid too
  tdsRate: number
  tdsAmount: number
  netPayout: number        // grossAmount + gstAmount − tdsAmount — actual cash transferred
  status: 'pending' | 'approved' | 'advice_generated' | 'paid'
  paymentDate: string | null
  createdAt: string
}

export const payoutStore = createStore<PayoutRow>('sp_payouts', [], 'PO', 2, '/payouts')
